import { renderAIHtml } from "../../common/renderAIHtml";

export function messageToEditorHtml(text = "") {
  let list = null;
  let html = "";
  for (const line of text.split("\n")) {
    const bullet = /^(?:•|-|\*)\s+/.exec(line);
    const numbered = /^\d+\.\s+/.exec(line);
    const kind = bullet ? "ul" : numbered ? "ol" : null;
    if (list !== kind) {
      if (list) html += `</${list}>`;
      if (kind) html += `<${kind}>`;
      list = kind;
    }
    const body = line.slice((bullet || numbered)?.[0].length || 0);
    const escaped = body.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    const inline = escaped.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2">$1</a>')
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      .replace(/(?<!\*)\*(?!\*)(.*?)(?<!\*)\*(?!\*)/g, "<em>$1</em>");
    const rendered = renderAIHtml(`<p>${inline}</p>`).replace(/^<p>|<\/p>$/g, "");
    html += kind ? `<li>${rendered || "<br>"}</li>` : `<p>${rendered || "<br>"}</p>`;
  }
  return html + (list ? `</${list}>` : "");
}

export function editorDeltaToMessage(delta) {
  const lines = [];
  let line = "";
  let number = 0;
  for (const op of delta.ops || []) {
    if (op.insert && typeof op.insert === "object" && typeof op.insert["tag-pill"] === "string") {
      line += `{${op.insert["tag-pill"]}}`;
      continue;
    }
    if (typeof op.insert !== "string") continue;
    const attributes = op.attributes || {};
    const parts = op.insert.split("\n");
    for (const [index, part] of parts.entries()) {
      if (part) {
        let formatted = part;
        if (attributes.italic) formatted = `*${formatted}*`;
        if (attributes.bold) formatted = `**${formatted}**`;
        if (/^https?:\/\//i.test(attributes.link || "")) formatted = `[${formatted}](${attributes.link})`;
        line += formatted;
      }
      if (index < parts.length - 1) {
        number = attributes.list === "ordered" ? number + 1 : 0;
        lines.push((attributes.list === "bullet" ? "• " : number ? `${number}. ` : "") + line);
        line = "";
      }
    }
  }
  if (line) lines.push(line);
  return lines.join("\n");
}
